module.exports = __webpack_public_path__ + "img/preloader-acts.37ffaaad.svg";